import './App.css';
import { Login } from './Pages/Login';
import { ConfigProvider, notification, Spin } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { Route, Routes } from 'react-router-dom'
import fa_IR from "antd/lib/locale/fa_IR";
import { Admin } from './Pages/Admin';
import { Helmet } from "react-helmet";
import { Get_Setting_Api, GetSiteTitle_Setting_Api } from './API/SettingApi';
import { useNavigate } from "react-router-dom";

// =================================================================
const Context = React.createContext({ name: 'Default' });
// =================================================================
function App() {
  const contextValue = useMemo(() => ({ name: 'Ant Design' }), []);
  const [notify, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);
  const [siteTitle, setSiteTitle] = useState();
  const navigate = useNavigate();
  
  // =================================================================
  useEffect(() => {
    loadSetting();
    checkUserLogin();
  }, []);
  // =================================================================
  const loadSetting = async () => {
    setLoading(true);
    try {
      const data = await GetSiteTitle_Setting_Api();
      setLoading(false);

      if (data.messageStatus == "Successful") {
        setSiteTitle(data.messageData.data);
      }
      else {

        showMessage(data.message, "error")
      }
    }
    catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور.", "error")
    }
  }
  // =================================================================
  const checkUserLogin = () => {
    var tkn = localStorage.getItem('token');
    if (!tkn || tkn.length < 3)
      navigate("/login");
  }
  // =================================================================
  const showMessage = async (text, messageType) => {
    if (messageType == "Successful") {
      notify.success({
        message: text,
        placement: 'bottomLeft',
      });
    }
    else if (messageType == "error") {
      notify.error({
        message: text,
        placement: 'bottomLeft',
      });
    }
  }

   // =================================================================
  return (
    <>
      <Helmet>
        <title>{siteTitle ? siteTitle : ""}</title>
      </Helmet>
      <ConfigProvider locale={fa_IR} theme={{
        token: {
          colorPrimary: '#00b96b',
          borderRadius: 2,
        }
      }}>

        <Context.Provider value={contextValue}>
          {contextHolder}
          <Routes>
            <Route path="/Login" element={<Login setLoading={setLoading} showMessage={showMessage} />} />
            <Route path="/Admin" element={<Admin setLoading={setLoading} showMessage={showMessage} />} />

            {/* <Route path="/ObjectType" element={<ObjectType setLoading={setLoading} showMessage={showMessage} />} /> */}
            {/* <Route path="/ObjectInstance" element={<ObjectInstance setLoading={setLoading} showMessage={showMessage} />} /> */}
            {/* <Route path="/Category" element={<Category setLoading={setLoading} showMessage={showMessage} />} /> */}
            {/* <Route path="/Price" element={<Price setLoading={setLoading} showMessage={showMessage} />} /> */}
            {/* <Route path="/Period" element={<Period setLoading={setLoading} showMessage={showMessage} />} /> */}

            <Route path="*" element={<Login setLoading={setLoading} showMessage={showMessage} />} />
          </Routes>



          <Spin spinning={loading} size="large" fullscreen />
        </Context.Provider>
      </ConfigProvider>
    </>
  );
}

export default App;
